export const WINDOW_WIDTH = "WINDOW_WIDTH";